import { BlockVariant, CustomBlockProps, DropdownListBlockProps, DynamicBlock, DynamicBlocks } from '@/components/block-builder/block-builder.types';
import { FileService, NAMESPACE_ENUM } from '@/components/shared/file-list/file-list.service';
import { OpinionBlockComponent } from '@/components/shared/opinion-block/opinion-block.component';
import { DacOpinion, JointDoc } from '@/types';
import { inject, Injectable } from '@angular/core';

interface DacMetadataBlocksService {
  pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>;
  dacOpinions?: DacOpinion[];
}

@Injectable({
  providedIn: 'root',
})
export class DacMetaDataBlocksService {
  fileService = inject(FileService);

  getPvsBlocks(pvItems?: Record<string, { items: JointDoc[]; nameSpace: NAMESPACE_ENUM }>): DynamicBlock[] {
    const bulltedLists: DynamicBlock<DropdownListBlockProps>[] = pvItems
      ? (Object.keys(pvItems)
          .map(key => {
            if (pvItems[key].items.length === 0) return null;
            return {
              variant: BlockVariant.DROPDOWN_LIST,
              props: {
                label: key,
                items: pvItems?.[key].items,
                renderAs: (item: JointDoc) => {
                  return {
                    type: 'LINK',
                    value: item.ref,
                    class: 'underline text-blue-600',
                  };
                },
                onClick: (item: JointDoc) => {
                  this.fileService.download({ alfresco_id: item.alfrescoId, filename: item.ref, extension: 'pdf' }, pvItems[key].nameSpace);
                },
              },
            };
          })
          .filter(Boolean) as DynamicBlock[])
      : [];
    return bulltedLists;
  }

  getDacOpinionsBlocks(dacOpinions?: DacOpinion[]): DynamicBlock<CustomBlockProps>[] {
    if (!dacOpinions || dacOpinions.length === 0) return [];

    return dacOpinions.map(opinion => ({
      variant: BlockVariant.CUSTOM,
      props: {
        component: OpinionBlockComponent,
        inputs: {
          avis: opinion.avis,
          user: opinion.user,
          createdAt: opinion.createdAt,
          alfrescoId: opinion.alfrescoId,
          namespace: NAMESPACE_ENUM.OPINION_DAC,
        },
      } satisfies CustomBlockProps,
    }));
  }

  getMetadataBlocks({ pvItems, dacOpinions }: DacMetadataBlocksService): { blocks: DynamicBlocks[]; isEmpty: boolean } {
    const pvBlocks = this.getPvsBlocks(pvItems);
    const opinionBlocks = this.getDacOpinionsBlocks(dacOpinions);

    const result: DynamicBlocks = {};
    let empty = true;

    if (pvBlocks && pvBlocks.length > 0) {
      result['1'] = pvBlocks;
      result['2'] = [
        {
          variant: BlockVariant.SEPERATOR,
        } satisfies DynamicBlock,
      ];
      empty = false;
    }

    if (opinionBlocks.length > 0) {
      result['3'] = opinionBlocks;
      empty = false;
    }

    return { blocks: [result], isEmpty: empty };
  }
}
